import Button from './Button';
import Text from './text';
import { colors } from '../config/theme';
import React from 'react';
import { ReactComponent as IconAlert } from '../assets/icons/IconAlert.svg';
import Element from './element';

const NoData = ({
  icon = IconAlert,
  msg = 'Oops, something went wrong.',
  btnTitle = 'Reload',
  btnClickCallBack
}) => {
  return (
    <Element textAlign="center">
      <Element type={icon} height="64px" width="64px" />
      <Text
        type="h3"
        size="24px"
        color={colors.dustyGray}
        margin="16px 0 32px 0"
      >
        {msg}
      </Text>
      <Button scheme="dark" onClick={btnClickCallBack}>
        {btnTitle}
      </Button>
    </Element>
  );
};

export default NoData;
